<template>
  <div class="btn">
    <van-button
      class="btnBox"
      :class="[light ? 'light' : 'gray']"
      round
      :plain="true"
      @click="click"
    >
      {{ btn }}
    </van-button>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import lang from '@/langs'

const emits = defineEmits(['click'])

const props = defineProps<{ active: number; light: boolean }>()
const btn = ref(lang('我已线下汇款，下一步'))
const light = ref(props.light)
const btnText = () => {
  if (props.active === 0) {
    btn.value = lang('我已线下汇款，下一步')
  } else if (props.active === 1) {
    btn.value = lang('提交')
  }
}
const click = () => {
  emits('click', props.active + 1)
}
watch(
  () => props.active,
  (value) => {
    btnText()
  }
)
watch(
  () => props.light,
  (value) => {
    light.value = value
  }
)
</script>

<style scoped lang="less">
.btn {
  //height: 58px;
  width: 100%;
  padding: 6px 16px;
  background: #fff;
  .btnBox {
    width: 100%;
    background: linear-gradient(
      90deg,
      rgba(250, 81, 15, 1),
      rgba(255, 0, 0, 1) 100%
    ); /* 从左到右的渐变 */
    color: #fff;
    font-weight: bold;
    font-size: 16px;
  }
  .light {
    background: linear-gradient(
      90deg,
      rgba(250, 81, 15, 1),
      rgba(255, 0, 0, 1) 100%
    ); /* 从左到右的渐变 */
  }
  .gray {
    background: rgba(216, 216, 216, 1);
  }
  border-top-width: 1px;
  border-top-color: rgba(242, 242, 242, 1);
}
</style>
